<template>
	<div
		class="tap-to-continue"
		:class="{ 'is-mobile': isMobile() }"
		:style="{ backgroundImage: bgImage }"
	>
		<img
			class="logo"
			:class="{ 'is-mobile': isMobile() }"
			:src="`${IMAGES_CDN_URL}/landing-page/${plagueFolder}${isMobile() ? 'portrait' : 'landscape'}-logo.avif`"
			alt="game-logo"
		/>
		<p class="cta-text" v-if="loadingDone">
			{{ translate("ui.tap_to_continue") }}
		</p>
		<p class="cta-text" v-else>
			{{ translate("ui.loading.non_translatable") }}
		</p>
		<p class="version">
			{{ version }} {{ ENV }}
			<span v-if="buildDate">({{ buildDate }})</span>
		</p>
		<img
			class="pps-logo"
			:src="`${IMAGES_CDN_URL}/landing-page/${plagueFolder}pps-logo.avif`"
			alt="pps-logo"
		/>
	</div>
</template>

<script lang="ts" setup>
import {
	ENV,
	IMAGES_CDN_URL,
	IS_DEV,
	IS_QA,
	PLAGUE_ENABLED,
} from "@/config/constants";
import { computed } from "vue";
import { version } from "../../package.json";
import { isMobile } from "../utils/isMobile";
import { translate } from "../utils/translate";

const { loadingDone } = defineProps<{
	loadingDone: boolean;
}>();

const plagueFolder = PLAGUE_ENABLED ? "plague/" : "";

const bgImage = computed(() => {
	const variant = isMobile() ? "portrait" : "landscape";
	return `url("${IMAGES_CDN_URL}/landing-page/${plagueFolder}${variant}-background-03-09-25.avif?v1")`;
});

const buildDate =
	IS_DEV || IS_QA
		? new Date(
				+(document.getElementById("app")?.dataset.buildTimestamp ?? ""),
			).toLocaleString("sk")
		: "";
</script>

<style lang="scss" scoped>
.tap-to-continue {
	position: fixed;
	z-index: 10;
	background-position: center;
	background-size: cover;
	background-repeat: no-repeat;
	background-color: #000; // Fallback black background
	width: 100%;
	height: 100%;
	pointer-events: none;

	.logo {
		position: absolute;
		top: 16%;
		left: 50%;
		transform: translate(-50%, -50%);
		max-width: 65%;

		&.is-mobile {
			top: 14.5%;
			max-width: 100%;
		}
	}

	.cta-text {
		position: absolute;
		bottom: 12.5%;
		left: 50%;
		transform: translate(-50%, -50%);
		animation: pulse 1s infinite;
		width: 100%;
		color: #fff3dd;
		font-size: 1.4rem;
		text-align: center;
		text-transform: uppercase;
	}

	.version {
		position: absolute;
		bottom: 1rem;
		left: 1rem;
		color: #fff3dd;
		font-size: 0.875rem;
		text-align: center;
		text-transform: uppercase;
	}

	.pps-logo {
		position: absolute;
		right: 1rem;
		bottom: 1rem;
		max-width: 7.5rem;
	}
}

@keyframes pulse {
	0%,
	100% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
}
</style>
